import {Component, Input, OnInit} from '@angular/core';
import {UserModel} from '../../../../models/user.model';

@Component({
  selector: 'app-user-information-form-part',
  templateUrl: './user-information-form-part.component.html',
  styleUrls: ['./user-information-form-part.component.scss']
})

export class UserInformationFormPartComponent implements OnInit {
  @Input() aplicant: UserModel=new UserModel();
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/+app-custom/components/publication-registration/base-publication-form-part/user-information-form-part/user-information-form-part.component.ts